export default "__VITE_ASSET__CRY5HSCw__"